import { oc } from "@orpc/contract";
import { z } from "zod";

/**
 * One comparison between what the migrations declare and what a database holds.
 *
 * `missing` and `unsanctioned` are the same comparison with opposite signs, and
 * `mismatched` is the case neither of the two existing tools reports: present
 * in both, but not the same.
 */
const reconciliationFindingSchema = z.object({
  status: z.enum(["missing", "unsanctioned", "mismatched"]),
  kind: z.enum(["table", "column", "enum", "index"]),
  /** Table name, `table.column`, enum name or index name. Also the action key. */
  id: z.string(),
  table: z.string().optional(),
  detail: z.string(),
  /** `unsanctioned` only: rows or values a drop would destroy. */
  usage: z.number().optional(),
  /** `unsanctioned` only: false when dropping it would destroy data. */
  safeToDrop: z.boolean().optional(),
  /** `missing` index only: the deferred builder has a plan for it. */
  buildable: z.boolean().optional(),
});

export const schemaReconciliationContracts = {
  /** Read-only. Everything this database and the migrations disagree about. */
  reconcileSchema: oc
    .input(z.object({}))
    .output(
      z.object({
        findings: z.array(reconciliationFindingSchema),
      }),
    )
    .route({
      summary: "Compare database schema against migrations",
      description:
        "Admin only, read-only. Lists tables, columns, enums and indexes that are missing, untracked or different between the database and migrations.",
    }),
};
